// extracted by mini-css-extract-plugin
export var accent = "_bc-4";
export var add = "_bc-j";
export var addIcon = "_bc-k";
export var deleteIcon = "_bc-i";
export var disabled = "_bc-9";
export var ellipsis = "_bc-f";
export var error = "_bc-3";
export var form = "_bc-5";
export var hideFocus = "_bc-2";
export var icon = "_bc-7";
export var input = "_bc-e";
export var listItem = "_bc-h";
export var mediumHeight = "_bc-b";
export var noBorder = "_bc-8";
export var noRadius = "_bc-1";
export var shortHeight = "_bc-a";
export var tallHeight = "_bc-c";
export var textInput = "_bc-0";
export var vertical = "_bc-g";
export var veryTallHeight = "_bc-d";
export var widget = "_bc-6";